import { StyleSheet, Text, View } from 'react-native';

import { ModernCard } from '@/components/shared/cards/ModernCard';
import { FimBouncingLogo } from '@/components/shared/FimBouncingLogo';
import { Spacing } from '@/constants/spacing';
import { Colors } from '@/constants/theme';
import { getBodyFont } from '@/constants/typography';
import { useColorScheme } from '@/hooks/use-color-scheme';

/**
 * Loading state for the Home day summary: a bouncing Fim logo inside the
 * summary card while the brief is being retrieved.
 */
export function SummaryLoadingCard() {
  const colorScheme = useColorScheme();
  const palette = Colors[colorScheme ?? 'light'];

  return (
    <View style={styles.container}>
      <ModernCard variant="elevated" padding="lg">
        <View style={styles.content}>
          <FimBouncingLogo />
          <Text style={[styles.caption, { color: palette.textMuted, fontFamily: getBodyFont() }]}>
            Fim is getting your brief...
          </Text>
        </View>
      </ModernCard>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: Spacing.sm,
    paddingTop: Spacing.sm,
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: Spacing.xl,
    gap: Spacing.md,
  },
  caption: {
    fontSize: 13,
    fontWeight: '500',
  },
});
